import React from 'react';

import type { SourceType } from '@trello/atlassian-analytics';
import { forNamespace, forTemplate } from '@trello/i18n';

import { PopOver } from 'app/scripts/views/lib/PopOver';
import {
  LazyAddCover as AddCover,
  LazySelectCover as SelectCover,
} from 'app/src/components/CardCoverChooser';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';

const format = forNamespace('view title');
const formatCardCoverChooser = forTemplate('card_cover_chooser');

export const toggleCardCoverChooserPopover = ({
  elem,
  cardId,
  boardId,
  traceSource,
}: {
  elem: Element;
  cardId: string;
  boardId: string;
  traceSource?: SourceType;
}) => {
  const addCover = (
    <ComponentWrapper key="add-cover">
      <AddCover
        cardId={cardId}
        // eslint-disable-next-line react/jsx-no-bind
        navigateToSelectCover={() => PopOver.popView()}
      />
    </ComponentWrapper>
  );

  const navigateToAddCover = () => {
    PopOver.pushView({
      getViewTitle: () => formatCardCoverChooser('photo-search'),
      reactElement: addCover,
      displayType: 'mod-card-cover-chooser',
    });
  };

  const selectCover = (
    <ComponentWrapper key="select-cover">
      <SelectCover
        {...{
          cardId,
          boardId,
          traceSource,
          navigateToAddCover,
        }}
      />
    </ComponentWrapper>
  );

  PopOver.toggle({
    elem,
    getViewTitle: () => format('cover'),
    reactElement: selectCover,
  });
};
